<template>
  <div class="CIT_background">
    <div
      v-if="loading"
      class="d-flex vertical-center justify-content-center align-items-center"
      style="height: 85vh; display: flex"
    >
      <LoadingMDL />
    </div>
    <div v-else class="position" style="display: flex; flex-direction: column">
      <div class="bg-image"></div>
      <div class="blur_bg">
        <div class="container_CIT02">
          <div class="block">
            <div
              v-if="videoLink == ''"
              class="d-flex vertical-center justify-content-center align-items-center"
            >
              <LoadingMDL />
            </div>
            <div v-else>
              <div class="text_completed_container">
                <a class="text_completed text-center">TEST COMPLETE</a>
              </div>
              <video width="90%" autoplay loop muted class="video_class">
                <source :src="videoLink" type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
        <CRow
          style="
            display: flex;
            justify-content: center;
            margin-left: auto;
            margin-right: auto;
          "
        >
          <div
            class="button button_setting"
            @click="nextRoute(content.navigate)"
          >
            <CCol col="12">
              <div style="font-size: 18px; padding: 0px 1px 0px 1px">NEXT</div>
            </CCol>
          </div>
        </CRow>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/signInCss/Button.vue';
import Card from '@/components/elements/Card.vue';
import {mapGetters} from 'vuex';
import TEMPLATE from '../../../TEMPLATE.vue';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  components: {Button, Card, TEMPLATE, LoadingMDL},
  name: 'LKI02',
  props: {},
  data() {
    return {
      content: {},
      baseUrl: process.env.VUE_APP_URL_SOUND,
      currentRoute: '',
      loading: true,
      content: [],
      videoLink: '',
      condition: [],
      templateData: [],
      startTime: this.$helpers.getDateFormat(),
      navigate: [],
      sound: {},
      showScore: 0,
      nextPath: null,
    };
  },
  methods: {
    onLoadData() {
      this.loading = true;
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    nextRoute: function () {
      // const str = this.navigate.next.action.split('-');
      // const path = `/v4/${str[0]}/${str[1]}`;
      // this.$router.push(path);
      this.commitPayloadData();
    },
    commitPayloadData() {
      const path = this.navigate.next.action;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      getTemplatev3: 'v3/getTemplates',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
      getScoreResultv4: 'v4-data/getScoreResultv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];

      this.navigate = template.navigate;

      this.content = template;

      //checking
      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.$store.dispatch(
        'v4-data/getScoreResultv4',
        this.$store.state.v4.v4DataStack
      );
    },
    getScoreResultv4: function (val) {
      console.log(val, 'score result');

      //assign score
      const userScore = String(val.score).padStart(2, '0');
      const maxScore = String(val.maxScore).padStart(2, '0');
      this.score = userScore + '/' + maxScore;
      this.showScore = val.score;

      //loading done after get score
      this.loading = false;
    },

    showScore(val) {
      let score = val || 0;
      if (score < 5) {
        this.sound = new Audio(
          'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Bad%20Soudtrack/multimedia_game_sound_synth_tone_bold_fail_52993.mp3'
        );
      } else if (score >= 5) {
        this.sound = new Audio(
          'https://mdl.mfu.ac.th/chinese2/Sound/All%20Sound/Good%20Sound%20Effect/cartoon_success_fanfair.mp3'
        );
      }

      let displayConditionArray = this.content.content.item;
      for (let i = 0; i < displayConditionArray.length; i++) {
        if (
          score >= displayConditionArray[i].choices.score &&
          score <= displayConditionArray[i].choices.max_score
        ) {
          this.videoLink =
            this.baseUrl + '' + displayConditionArray[i].media.url;
        }
      }
      this.sound.play();
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.position {
  display: flex;
  align-content: center;
  justify-content: center;
}
.block {
  width: 650px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12%;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 20px;
}
.card {
  width: 400px;
  height: 400px;
  border-radius: 10px; /* 5px rounded corners */
  border: 2px solid;
  margin: 0;
  display: flex;
  justify-content: center;
}
.container_CIT02 {
  margin-left: auto;
  margin-right: auto;
}
.text_completed {
  font-size: 36px;
  color: #fe9774;
}
.text_completed_container {
  margin-top: 20px;
  margin-bottom: 15px;
}
.button_setting {
  background-color: #89abe6;
  width: 40%;
  height: 60px;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 7px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 50%;
}
.bg-image {
  background-image: linear-gradient(90deg, #ffdc77 0%, #fff 50%, #ffccd5 100%);
  filter: blur(1px);
  -webkit-filter: blur(1px);
  height: 1080px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.video_class {
  margin-bottom: 25px;
}
.blur_bg {
  font-weight: bold;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  z-index: 2;
  text-align: center;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .block {
    width: 300px;
    height: auto;
    margin-top: 1%;
  }
  .video_class {
    margin-bottom: 10px;
  }
  .card {
    width: 200px;
    height: 200px;
  }
  .btn-prev {
    width: 50px;
    height: 50px;
    padding: 10px;
    right: 102%;
  }
  .bg-image {
    height: 700px;
  }
  .button_setting {
    width: 130px;
    height: 45px;
  }
  .text_completed_container {
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .text_completed {
    font-size: 20px;
    color: #fe9774;
  }
  .blur_bg {
    font-weight: bold;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%);
    z-index: 2;
    text-align: center;
  }
}
</style>
